import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from '@/components/ui/input';

/**
 * Password field with an eye button to show or hide what was typed, so
 * people can check their password instead of typing it twice.
 */
export default function PasswordInput({ className = '', testId, ...props }) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input
        {...props}
        type={visible ? 'text' : 'password'}
        className={`${className} pr-14`}
        data-testid={testId}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="absolute inset-y-0 right-0 w-14 flex items-center justify-center text-gray-500 hover:text-farm-primary"
        aria-label={visible ? t('auth.hidePassword') : t('auth.showPassword')}
        aria-pressed={visible}
        data-testid={testId ? `${testId}-toggle` : undefined}
      >
        {visible ? <EyeOff className="w-6 h-6" /> : <Eye className="w-6 h-6" />}
      </button>
    </div>
  );
}
